import React from "react";
// import Message from "../components/Message";

import { StyledMessage } from "../components/Styles";

function P404() {
  return (
    <div
      style={{
        height: `calc(100vh - 160px)`,
      }}
    >
      <StyledMessage.Text variant="green" fixed>
        Page Not Found
      </StyledMessage.Text>
    </div>
  );
}

export default P404;
